import Header from './Header'
import Footer from './Footer'
import { InstallBanner } from '../common/InstallPWA'

function Layout({ children }) {
  return (
    <>
      <InstallBanner />
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default Layout
